import gcsData from "./gcsData";
import saData from "./saData";
import srtData from "./srtData";
import wbData from "./wbData";

const apps = {
  "schedule-recurring-tasks": srtData,
  "google-calendar-sync": gcsData,
  "special-automations": saData,
  "workflow-blocks-plus": wbData,
};

export default apps;
